<div class="event-extra-card">
  <div class="card-header">
    <h3 class="section-title">Event ekstra indstillinger</h3>
    <p class="section-desc">Specifikke tilvalg for det aktuelle event.</p>
  </div>

  @if (loading) {
  <p class="loading-message">Henter event-indstillinger...</p>
  } @if (errorMessage) {
  <p class="error-message">{{ errorMessage }}</p>
  } @if (!loading) {
  <section class="settings-section">
    <h4 class="subsection-title">Checkbokse</h4>
    <div class="checkbox-list">
      <mat-checkbox [(ngModel)]="model.cleaning">Rengøring</mat-checkbox>
      <mat-checkbox [(ngModel)]="model.certificates_created"
        >Beviser oprettet</mat-checkbox
      >
    </div>
  </section>
  <div class="form-actions">
    <button
      mat-raised-button
      color="primary"
      [disabled]="saving"
      (click)="save()"
    >
      {{ saving ? "Gemmer..." : "Gem indstillinger" }}
    </button>
  </div>
  }
</div>
